import {teamBuildingErrorKey} from 'app/services/operation-conflict';
import 'rxjs/add/observable/forkJoin';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/timer';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import { GroupContext } from '../../../models/group-context.model';
import { Group } from '../../../models/group.model';
import { Prefix } from '../../../models/prefix.model';
import { AdminService } from '../../../services/admin.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Schedule } from '../../../models/schedule.model';
import { TimeFormatterService } from '../../../services/time-formatter.service';
import { isUndefined } from 'util';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { PrefixService } from '../../../services/prefix.service';
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user.model';
import { NgbModal, NgbModalRef, NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { CreateSchedulePopupComponent } from '../../admin/create-schedule-popup/create-schedule-popup.component';
import { ConfirmPopupComponent } from '../view-group/popups/confirm-popup copy/confirm-popup.component';

const FIRST_INDEX = 0;
const HTTP_OK = 200;
const HTTP_CREATED = 201;
const HTTP_NO_CONTENT = 204;
const HTTP_ALREADY_REPORTED = 208;
const HTTP_UNAUTHORIZED = 401;
const HTTP_FORBIDDEN = 403;
const HTTP_CONFLICT = 409;
const EMPTY_TEXT = '';
const DEPARTMENT_TYPE = 'DEPARTMENT';
const AFFILIATE_TYPE = 'AFFILIATE';
const SAVE_SUCCESS_DELAY = 3000;
const SAVE_CONFLICT_DELAY = 5000;
const SCHEDULE_UPDATED = 'SCHEDULE_UPDATING';
const SCHEDULE_CONFLICT = 'ERRORCONFLICT';
const GROUP_LOAD_ERROR = 'ERROR_LOADING_DEPARTMENT';
const SCHEDULES_LOAD_ERROR = 'ERROR_LOADING_SCHEDULES_LIST';
const AFFILIATES_LOAD_ERROR = 'ERROR_LOADING_AFFILIATES_LIST';
const ROUTE_ID = 'id';
const BOOLEAN_TYPE = 'boolean';
const DATE_SEPARATOR = '-';
const DATE_PADDING = '0';
const NEXT_DAY = 1;
const MONTH_OFFSET = 1;
const TWO_DIGIT_LIMIT = 10;
const TIME_SECONDS_LENGTH = 3;
const SCHEDULE_SEPARATOR = ' - ';
const SELECT_SCHEDULE = 'SELECT';
const NO_SUBDIVISIONS = 'NO_SUBDIVISIONS';
const SUBDIVISIONS_ERROR_TEXT = "Can't get any subdivisions";
const NO_AFFILIATES = 'NO_AFFILIATE_GROUPS';
const AFFILIATES_ERROR_TEXT = 'C_A_G';
const NO_GLOBALS = 'NO_GLOBAL_GROUPS';
const GLOBALS_ERROR_TEXT = 'C_G_A_G';
const GLOBALS_LOAD_ERROR = 'E_G_D_L';
const DEPARTMENTS_LOAD_ERROR = 'ERROR_LOADING_SUBDIVISIONS_LIST';
const STANDARD_TAB = 'standard';
const FLEXIBLE_TAB = 'flex';
const TEAM_TAB = 'build';
const SETTINGS_SAVE_ERROR = 'GROUP_SETTINGS_SAVE_ERROR';
const PREFIX_SAVE_ERROR = 'Prefix update was not accepted';
const SCHEDULE_CREATED = 'SCHEDULE_CREATING';
const TEAM_USER_ADDED = 'USER_ADDED';
const TEAM_USER_DELETED = 'USER_DELETED';
const TEAM_DELETED = 'TEAM_DELETED';
const TEAM_RELOAD_FAILED = 'TEAM_BUILDING_RELOAD_FAILED';
const NO_SCHEDULES = 0;
const MODAL_CONFIRMED = 'ok';
const MODAL_CONTEXT_CHANGED = 'group context changed';
const FLEXIBLE_SCHEDULE_TYPE = 'FLEXIBLE';
const STRING_TYPE = 'string';
const SCHEDULE_MODAL_TYPE = 'MODAL';
const SCHEDULE_MODAL_OPTIONS = { size: 'lg' as 'lg', backdrop: 'static' as 'static', windowClass: 'full-screen-modal' };

interface EditorScheduleDraft {
  id?: string;
  period: {
    theBeginingOfTheWorkDay: string;
    theBeginingOfTheLunch: string;
    endOfTheLunch: string;
    endOfTheWorkingDay: string;
  };
  schedules: { workDays: number; restDays: number }[];
}

interface EditorTeamRequest {
  title: string;
  groupId: string;
  scheduleId: string;
  from: string;
  users: string[];
}

interface EditorGroup extends Group {
  relativeGroup: string[];
  workScheduleId2?: Schedule;
  workScheduleId3?: Schedule;
  workScheduleCheckvox: boolean;
  workSchedule2Checkvox: boolean;
  workSchedule3Checkvox: boolean;
}

interface EditorGroupRequest {
  id: string;
  name: string;
  groupType: string;
  relativeGroup: string[];
  workScheduleId: string;
  workScheduleId2: string;
  workScheduleId3: string;
  workScheduleCheckvox: boolean;
  workSchedule2Checkvox: boolean;
  workSchedule3Checkvox: boolean;
  flexibleWorkSchedules: string[];
}

interface EditorSchedules {
  STANDARD: Schedule[];
  FLEXIBLE: Schedule[];
}

@Component({
  selector: 'app-edit-group-details',
  templateUrl: './edit-group-details.component.html',
  styleUrls: ['./edit-group-details.component.css'],
})
export class EditGroupDetailsComponent implements OnInit, OnDestroy {
  isLoaded = false;
  showErrorMsg = false;
  loadingErrorMsg = '';
  departmentsForm: FormGroup;
  public group: any;
  public name: string;
  public workSchedule: Schedule;
  public workSchedule2: Schedule;
  public workSchedule3: Schedule;
  public schedulesList: any[] = [];
  public schedulesListNoFormated: any;
  public selectedScheduleName = 'SELECT';
  public selectedScheduleName2 = 'SELECT';
  public selectedScheduleName3 = 'SELECT';
  public successInfo = false;
  public errorInfo = false;
  validationFailed: boolean;
  getSubdivisionsErrorInfo = false;
  getAffiliatesErrorInfo = false;
  getGlobalsErrorInfo = false;
  noSubdivisionsInfo = false;
  noAffiliatesInfo = false;
  noGlobalsInfo = false;
  isEditBtnDisabled = true;
  isAffiliate = false;
  isDepartment = false;
  selectedType = 'GLOBAL';
  subdivisions = [];
  affiliates = [];
  globals = [];
  selectedSubdivisions = [];
  selectedSubdivision = '';
  selectedSubdivisionId = '';
  selectedScheduleId = '';
  selectedScheduleId2 = '';
  selectedScheduleId3 = '';
  selectedAffiliate = '';
  selectedAffiliateId = '';
  selectedAffiliateObj = null;
  selectedGlobal = '';
  selectedGlobalId = '';
  titleValue = '';
  errorName = false;
  currentGroupName = '';
  currentGroupType = '';
  infoLoaded = false;
  moveToType = '';
  currentGroupRelatives = [];
  errorMsg = '';
  myCroupPrefix;
  prefix;
  user: User;
  isAdmin = false;
  isHead = false;
  isUser = false;
  flag = true;
  id;
  workScheduleCheckvox = false;
  workSchedule2Checkvox = false;
  workSchedule3Checkvox = false;
  sheduleListFlexible;
  flexShedulesDeratment;
  currentShedList = [];
  dropdowns: { id?: any, open: boolean, selected: any, selectedScheduleName?: string, period: any, schedules: { workDays: number, restDays: number }[] }[] = [];
  from: Date;
  sheduleId: string;
  messageSuccess;
  messageDanger;
  scheduleDropdowns: any[] = [];
  today: string;
  currentListSHedulerTeamBuilding;
  currentUser;
  scheduleList = [];
  allSchedulesUsed: boolean = false;
  checkSheduleList = [];
  isAnyScheduleAvailable: boolean = true;
  isLoading = false;
  constName = null;
  originalDropdowns;
  groupContext: GroupContext = null;
  contextLoading = false;
  contextError = false;
  schedulesLoading = false;
  activeScheduleTab = STANDARD_TAB;
  teamRequiresReload = false;
  teamLoading = false;
  teamErrorKey = EMPTY_TEXT;
  private groupChanged$ = new Subject<void>();
  private destroy$ = new Subject<void>();
  private loadedPrefixName: string = null;
  private groupModal: NgbModalRef = null;
  private schedulesLoaded = false;

  constructor(public adminService: AdminService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    public prefixService: PrefixService,
    private userService: UserService) {
    this.id = this.route.snapshot.params['id'];
    this.currentUser = JSON.parse(localStorage.getItem('User')).mainGroup;
  }

  ngOnInit(): void {
    this.checkRole();
    this.route.params.map(params => params[ROUTE_ID]).distinctUntilChanged()
      .takeUntil(this.destroy$).subscribe(id => this.selectGroup(id));
    this.today = this.tomorrowDate();
  }

  private tomorrowDate(): string {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + NEXT_DAY);
    return [tomorrow.getFullYear(), this.padDate(tomorrow.getMonth() + MONTH_OFFSET),
      this.padDate(tomorrow.getDate())].join(DATE_SEPARATOR);
  }

  private padDate(value: number): string {
    return value < TWO_DIGIT_LIMIT ? DATE_PADDING + value : String(value);
  }

  ngOnDestroy(): void {
    this.clearGroupContext();
    this.groupChanged$.next();
    this.groupChanged$.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  get canManageGroupSettings(): boolean {
    return this.isLoaded && !this.showErrorMsg && !!this.group && !!this.groupContext && this.groupContext.groupId === this.group.id
      && this.groupContext.canManageGroupSettings === true && !this.contextLoading && !this.contextError;
  }

  private selectGroup(id: string): void {
    this.id = id;
    this.activeScheduleTab = STANDARD_TAB;
    this.teamRequiresReload = this.teamLoading = false;
    this.teamErrorKey = EMPTY_TEXT;
    this.getGroupInfoById();
  }

  get canSaveSettings(): boolean {
    return this.canManageGroupSettings && this.schedulesLoaded && !this.isLoading && !this.schedulesLoading && !this.teamRequiresReload && !this.teamLoading;
  }

  private clearGroupContext(): void {
    this.dismissGroupModal();
    this.groupContext = null;
    this.contextLoading = false;
    this.contextError = false;
  }

  retryGroupContext(): void {
    this.getGroupInfoById();
  }

  private loadGroupContext(): void {
    this.contextLoading = true;
    this.adminService.getGroupContext(this.id)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(response => this.applyGroupContext(response), () => this.failGroupContext());
  }

  private applyGroupContext(response: HttpResponse<GroupContext>): void {
    const context = response.body;
    if (response.status !== HTTP_OK || !context || context.groupId !== this.id
      || typeof context.canManageGroupSettings !== BOOLEAN_TYPE || !Array.isArray(context.subdepartments)) {
      this.failGroupContext();
      return;
    }
    this.groupContext = context;
    this.contextLoading = false;
    this.contextError = false;
  }

  private failGroupContext(): void {
    this.clearGroupContext();
    this.contextError = true;
  }

  onTabChange(event: NgbTabChangeEvent): void {
    this.activeScheduleTab = event.nextId;
    if (event.nextId === FLEXIBLE_TAB) {
      this.scheduleDropdowns = [];
      this.scheduleList = [];
      this.checkSheduleList = [];
      this.getSchedulesList();
    }
    if (event.nextId === TEAM_TAB && !this.teamRequiresReload) {
      this.getGroupInfoById();
    }
  }

  openNewSchedule() {
    this.scheduleDropdowns.unshift({
      title: '',
      groupId: this.group.id,
      scheduleId: '',
      from: '',
      users: this.group.activeUsers.map(activeUser => ({
        user: activeUser.user,
        selected: false
      })),
      open: true
    });
  }

  pushData(data: any[]): void {
    const openStates = this.scheduleDropdowns ? this.scheduleDropdowns.map(scheduleDropdown => scheduleDropdown.open) : [];

    this.scheduleDropdowns = data.map(group => ({
      title: group.title,
      id: group.id,
      scheduleId: group.schedule ? group.schedule.id : '',
      schedule: group.schedule ? group.schedule : {},
      from: group.from,
      open: openStates.length ? openStates.find((state, index) => this.scheduleDropdowns[index].id === group.id) : false,
      users: this.group.activeUsers.map(activeUser => ({
        user: activeUser.user,
        selected: group.users.some(groupUser => groupUser.id === activeUser.user.id)
      }))
    }));

    this.checkList();
  }

  updateUserSelection(scheduleIndex: number, userId: string): void {
    const scheduleDropdown = this.scheduleDropdowns[scheduleIndex];
    const userIndex = scheduleDropdown.users.findIndex(user => user.id === userId);
    if (userIndex > -1) {
      scheduleDropdown.users[userIndex].selected = !scheduleDropdown.users[userIndex].selected;
    }
  }

  saveSchedule(scheduleIndex: number) {
    const newSchedule = this.scheduleDropdowns[scheduleIndex];
    const selectedUserIds = newSchedule.users.filter(user => user.selected).map(user => user.user.id);
    const requestData = {
      title: newSchedule.title,
      groupId: this.group.id,
      scheduleId: newSchedule.scheduleId,
      from: newSchedule.from,
      users: selectedUserIds
    }
    this.addTemplateTeamBuilding(requestData, scheduleIndex);
  }

  getAllTeamBuilding(): void {
    this.teamLoading = true;
    this.adminService.getAllTeamBuilding(this.group.id)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$).subscribe(list => {
        if (!this.validTeamList(list)) { this.rejectTeamLoad(); return; }
        this.currentListSHedulerTeamBuilding = list.slice().reverse();
        this.pushData(this.currentListSHedulerTeamBuilding);
        this.teamLoading = false;
      }, () => this.rejectTeamLoad());
  }

  private validTeamList(list: {id: string; users: Object[]}[]): boolean {
    return Array.isArray(list) && list.every(team => !!team && !!team.id && Array.isArray(team.users));
  }

  private rejectTeamLoad(): void {
    this.teamLoading = false;
    this.teamRequiresReload = true;
    this.teamErrorKey = TEAM_RELOAD_FAILED;
  }

  reloadTeamBuilding(): void {
    if (this.isLoading || this.teamLoading || !this.group) { return; }
    const groupId = this.group.id;
    this.teamLoading = true;
    Observable.forkJoin(this.adminService.getGroupByID(groupId) as Observable<HttpResponse<EditorGroup>>, this.adminService.getGroupContext(groupId),
      this.adminService.getAllTeamBuilding(groupId)).takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(result => this.acceptTeamReload(result), () => this.rejectTeamLoad());
  }

  private acceptTeamReload(result: [HttpResponse<EditorGroup>, HttpResponse<GroupContext>, {id: string; users: Object[]}[]]): void {
    const [response, contextResponse, teams] = result;
    const group = response.body;
    const context = contextResponse.body;
    if (response.status !== HTTP_OK || !group || group.id !== this.id || !Array.isArray(group.activeUsers) ||
      contextResponse.status !== HTTP_OK || !context || context.groupId !== this.id ||
      typeof context.canManageGroupSettings !== BOOLEAN_TYPE || !Array.isArray(context.subdepartments) || !this.validTeamList(teams)) {
      this.rejectTeamLoad(); return;
    }
    this.group = group;
    this.applyGroupIdentity(group);
    this.applyGroupSchedules(group);
    this.applyGroupContext(contextResponse);
    this.currentListSHedulerTeamBuilding = teams.slice().reverse();
    this.pushData(this.currentListSHedulerTeamBuilding);
    this.teamLoading = this.teamRequiresReload = false;
    this.teamErrorKey = this.messageDanger = this.messageSuccess = EMPTY_TEXT;
  }

  private failTeamSave(error?: HttpErrorResponse): void {
    this.failGroupSave(error);
    this.teamRequiresReload = true;
    this.teamErrorKey = teamBuildingErrorKey(error);
    this.messageDanger = EMPTY_TEXT;
  }

  addTemplateTeamBuilding(params: EditorTeamRequest, scheduleIndex: number): void {
    if (!this.canSaveSettings) { return; }
    this.beginGroupSave();
    this.adminService.teamScheduleBuilding(params)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(team => this.acceptTeamSave(team, SCHEDULE_CREATED), error => this.failTeamSave(error));
  }

  getFilteredScheduleList(currentId: number): any[] {
    return this.scheduleList.filter(item => 
      !this.scheduleDropdowns.some(dropdown => dropdown.scheduleId === item.id) || item.id === currentId
    );
  }

  onScheduleChange(scheduleIndex: number): void {
    const scheduleDropdown = this.scheduleDropdowns[scheduleIndex];
    if (scheduleDropdown.id) {
      this.updateTeamScheduleBuildingShedule(scheduleDropdown.id, scheduleDropdown.scheduleId);
    }
  }

  updateTeamScheduleBuildingShedule(id: string, scheduleId: string): void {
    if (!this.canSaveSettings) { return; }
    this.beginGroupSave();
    this.adminService.updateTeamScheduleBuilding(id, scheduleId)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(team => this.acceptTeamSave(team, SCHEDULE_UPDATED, id), error => this.failTeamSave(error));
  }

  updateTeamScheduleBuildingUsers(id: string, idUser: string): void {
    if (!this.canSaveSettings) { return; }
    this.beginGroupSave();
    this.adminService.updateTeamAddUser(id, idUser)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(team => this.acceptTeamSave(team, TEAM_USER_ADDED, id), error => this.failTeamSave(error));
  }

  deleteTeamScheduleBuildingUsers(id: string, idUser: string): void {
    if (!this.canSaveSettings) { return; }
    this.beginGroupSave();
    this.adminService.updateTeamRemoveUser(id, idUser)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(team => this.acceptTeamSave(team, TEAM_USER_DELETED, id), error => this.failTeamSave(error));
  }

  openmodalDel(id: string, scheduleIndex: number): void {
    if (!this.canSaveSettings) { return; }
    const modalRef = this.modalService.open(ConfirmPopupComponent);
    this.observeGroupModal<string>(modalRef).subscribe(result => {
      if (result === MODAL_CONFIRMED) {
        this.deletebataysk(id, scheduleIndex);
      }
    }, () => {});
  }

  private observeGroupModal<T>(modal: NgbModalRef): Observable<T> {
    this.groupModal = modal;
    return Observable.fromPromise<T>(modal.result)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$);
  }

  private dismissGroupModal(): void {
    const modal = this.groupModal;
    this.groupModal = null;
    if (modal) { modal.dismiss(MODAL_CONTEXT_CHANGED); }
  }

  deletebataysk(id: string, scheduleIndex: number): void {
    if (!this.canSaveSettings) { return; }
    this.beginGroupSave();
    this.adminService.deleteTeamScheduleBuilding(id)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(() => this.finishTeamRemoval(TEAM_DELETED), error => this.failTeamSave(error));
  }

  private acceptTeamSave(team: {id: string; users: Object[]}, message: string, id?: string): void {
    if (!team || !team.id || !Array.isArray(team.users) || (id && team.id !== id)) { this.failTeamSave(); return; }
    this.finishTeamSave(message);
  }

  private finishTeamSave(message: string): void {
    this.isLoading = false;
    this.messageDanger = EMPTY_TEXT;
    this.messageSuccess = message;
    this.getAllTeamBuilding();
    Observable.timer(SAVE_SUCCESS_DELAY).takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(() => this.messageSuccess = EMPTY_TEXT);
  }

  private finishTeamRemoval(message: string): void {
    this.isLoading = false;
    this.messageSuccess = EMPTY_TEXT;
    this.messageDanger = message;
    this.getAllTeamBuilding();
    Observable.timer(SAVE_SUCCESS_DELAY).takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(() => this.messageDanger = EMPTY_TEXT);
  }

  routTo(id) {
    this.router.navigateByUrl('/dashboard/admin/create-schedule/' + id)
  }

  addDropdown(result) {
    this.dropdowns.push({
      selectedScheduleName: '',
      period: {
        endOfTheLunch: '',
        endOfTheWorkingDay: '',
        theBeginingOfTheLunch: '',
        theBeginingOfTheWorkDay: '',
      },
      schedules: [],
      open: false,
      selected: false
    });
    const newIndex = this.dropdowns.length - 1;
    this.updatePeriod(newIndex, result);
  }

  addSchedule(dropdownIndex: number, event: Event) {
    event.stopPropagation();
    this.dropdowns[dropdownIndex].schedules.push({ workDays: 1, restDays: 1 });
  }

  updateWorkDays(dropdownIndex: number, scheduleIndex: number, workDays: number) {
    this.dropdowns[dropdownIndex].schedules[scheduleIndex].workDays = workDays < 1 ? 1 : workDays;
  }

  updateRestDays(dropdownIndex: number, scheduleIndex: number, restDays: number) {
    this.dropdowns[dropdownIndex].schedules[scheduleIndex].restDays = restDays < 1 ? 1 : restDays;
  }

  validateInput(dropdownIndex: number, scheduleIndex: number, field: string) {
    if (field === 'workDays') {
      this.dropdowns[dropdownIndex].schedules[scheduleIndex].workDays = this.dropdowns[dropdownIndex].schedules[scheduleIndex].workDays < 1 ? 1 : this.dropdowns[dropdownIndex].schedules[scheduleIndex].workDays;
    } else if (field === 'restDays') {
      this.dropdowns[dropdownIndex].schedules[scheduleIndex].restDays = this.dropdowns[dropdownIndex].schedules[scheduleIndex].restDays < 1 ? 1 : this.dropdowns[dropdownIndex].schedules[scheduleIndex].restDays;
    }
  }

  removeSchedule(dropdownIndex: number, scheduleIndex: number) {
    this.dropdowns[dropdownIndex].schedules.splice(scheduleIndex, 1);
  }

  removeDropdown(dropdownIndex: number) {
    this.dropdowns.splice(dropdownIndex, 1);
  }

  saveSchedules(dropdownIndex: number) {
    this.createSchedule(this.dropdowns[dropdownIndex], dropdownIndex);
  }

  createSchedule(schedule: EditorScheduleDraft, dropdownIndex: number): void {
    if (!this.canSaveSettings) { return; }
    const currentSchedule = {
      workStart: schedule.period.theBeginingOfTheWorkDay,
      lunchStart: schedule.period.theBeginingOfTheLunch,
      lunchEnd: schedule.period.endOfTheLunch,
      workEnd: schedule.period.endOfTheWorkingDay,
      type: FLEXIBLE_SCHEDULE_TYPE,
      segments: schedule.schedules
    };
    this.beginGroupSave();
    this.adminService.createSchedule(currentSchedule)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(response => this.finishScheduleCreation(response, schedule), error => this.failGroupSave(error));
  }

  private finishScheduleCreation(response: HttpResponse<Object>, schedule: EditorScheduleDraft): void {
    const created = response.body as { id?: string };
    if ((response.status !== HTTP_CREATED && response.status !== HTTP_OK) || !created || !created.id) {
      this.failGroupSave(null);
      return;
    }
    schedule.id = created.id;
    this.isLoading = false;
    this.successInfo = true;
    this.errorInfo = false;
    this.messageDanger = EMPTY_TEXT;
  }

  openSchedule(): void {
    if (!this.canSaveSettings) { return; }
    const modalRef = this.modalService.open(CreateSchedulePopupComponent, SCHEDULE_MODAL_OPTIONS);
    modalRef.componentInstance.type = SCHEDULE_MODAL_TYPE;
    this.observeGroupModal<Object>(modalRef).subscribe(result => {
      if (result && this.canSaveSettings && this.isValidResult(result)) {
        this.addDropdown(result);
      }
    }, () => {});
  }

  isValidResult(result: any): boolean {
    const expectedKeys = ['theBeginingOfTheWorkDay', 'theBeginingOfTheLunch', 'endOfTheLunch', 'endOfTheWorkingDay'];
    return expectedKeys.every(key => result.hasOwnProperty(key));
  }

  updatePeriod(dropdownIndex: number, schedule: any) {
    this.dropdowns[dropdownIndex].open = !this.dropdowns[dropdownIndex].open;
    this.dropdowns[dropdownIndex].period.endOfTheLunch = schedule.endOfTheLunch;
    this.dropdowns[dropdownIndex].period.endOfTheWorkingDay = schedule.endOfTheWorkingDay;
    this.dropdowns[dropdownIndex].period.theBeginingOfTheLunch = schedule.theBeginingOfTheLunch;
    this.dropdowns[dropdownIndex].period.theBeginingOfTheWorkDay = schedule.theBeginingOfTheWorkDay;
    this.dropdowns[dropdownIndex].selectedScheduleName = `${schedule.theBeginingOfTheWorkDay} - ${schedule.endOfTheWorkingDay}`;
  }

  checkRole() {
    this.user = this.userService.getLocal();
    if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
      this.isHead = true;
    } else {
      this.isHead = false;
    }
    if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }
    if (this.user.roles.indexOf('ROLE_USER') !== -1) {
      this.isUser = true;
    } else {
      this.isUser = false;
    }
  }

  titleValueEmpty(value) {
    value = value.trim();
    this.isEditBtnDisabled = !(value !== '' && value !== undefined);
  }

  checkList(): void {
    const availableSchedules = this.checkSheduleList.filter(item => !this.scheduleDropdowns.some(dropdown => dropdown.scheduleId === item.id));
    this.isAnyScheduleAvailable = availableSchedules.length > NO_SCHEDULES;
  }

  getGroupInfoById(): void {
    this.groupChanged$.next();
    this.clearGroupContext();
    this.group = null;
    this.resetGroupEditor();
    this.isLoaded = false;
    this.showErrorMsg = false;
    this.loadingErrorMsg = EMPTY_TEXT;
    this.adminService.getGroupByID(this.id)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe((response: HttpResponse<EditorGroup>) => this.applyGroupResponse(response),
        () => this.failGroupLoad(GROUP_LOAD_ERROR));
  }

  private resetGroupEditor(): void {
    this.isLoading = this.teamLoading = false;
    this.schedulesLoaded = false;
    this.schedulesLoading = false;
    this.dropdowns = [];
    this.originalDropdowns = [];
    this.loadedPrefixName = null;
    this.myCroupPrefix = null;
    this.prefixService.setGroupPrefixex([]);
    this.prefixService.setSelectedPrefix(null);
    this.messageSuccess = EMPTY_TEXT;
    this.messageDanger = EMPTY_TEXT;
    this.constName = null;
    this.scheduleDropdowns = [];
  }

  private applyGroupResponse(response: HttpResponse<EditorGroup>): void {
    if (response.status !== HTTP_OK || !response.body || response.body.id !== this.id) {
      this.failGroupLoad(GROUP_LOAD_ERROR);
      return;
    }
    this.group = response.body;
    this.applyGroupIdentity(response.body);
    this.applyGroupSchedules(response.body);
    this.getAllTeamBuilding();
    this.getSchedulesList();
    this.retryGroups();
    this.loadGroupContext();
  }

  private applyGroupIdentity(group: EditorGroup): void {
    this.name = group.name;
    this.titleValue = group.name;
    this.currentGroupName = group.name;
    this.currentGroupType = group.groupType;
    this.titleValueEmpty(group.name);
    this.infoLoaded = true;
    this.selectType(group.groupType);
    this.currentGroupRelatives = (group.relativeGroup || []).filter(id => !!id);
    this.selectedSubdivisions = this.currentGroupRelatives.slice();
    this.selectedSubdivisionId = EMPTY_TEXT;
  }

  private applyGroupSchedules(group: EditorGroup): void {
    this.scheduleList = group.flexibleWorkSchedule || [];
    this.flexShedulesDeratment = this.scheduleList;
    this.checkSheduleList = this.scheduleList;
    this.workSchedule = group.workSchedule;
    this.workSchedule2 = group.workScheduleId2 || null;
    this.workSchedule3 = group.workScheduleId3 || null;
    this.selectedScheduleId = this.workSchedule ? this.workSchedule.id : EMPTY_TEXT;
    this.selectedScheduleId2 = this.workSchedule2 ? this.workSchedule2.id : EMPTY_TEXT;
    this.selectedScheduleId3 = this.workSchedule3 ? this.workSchedule3.id : EMPTY_TEXT;
    this.workScheduleCheckvox = group.workScheduleCheckvox;
    this.workSchedule2Checkvox = group.workSchedule2Checkvox;
    this.workSchedule3Checkvox = group.workSchedule3Checkvox;
    this.selectedScheduleName = this.scheduleName(this.workSchedule);
    this.selectedScheduleName2 = this.scheduleName(this.workSchedule2);
    this.selectedScheduleName3 = this.scheduleName(this.workSchedule3);
  }

  private scheduleName(schedule: Schedule): string {
    return schedule ? schedule.workStart.slice(FIRST_INDEX, -TIME_SECONDS_LENGTH) + SCHEDULE_SEPARATOR
      + schedule.workEnd.slice(FIRST_INDEX, -TIME_SECONDS_LENGTH) : SELECT_SCHEDULE;
  }

  private failGroupLoad(message: string): void {
    this.isLoaded = true;
    this.showErrorMsg = true;
    this.loadingErrorMsg = message;
  }

  saveSelectedSchedulesForUpdateTitle() {
    if (!this.canSaveSettings) { return; }
    const selectedIds = this.dropdowns
      .filter(item => item.selected)
      .map(item => item.id);
    this.editDivision(selectedIds);
  }

  private saveEditedPrefix(): Observable<Object> {
    if (this.isAdmin && this.myCroupPrefix && this.loadedPrefixName !== null
      && this.myCroupPrefix.name !== this.loadedPrefixName) {
      const submittedName = this.myCroupPrefix.name;
      return this.prefixService.editPrefixInGroupPre(this.myCroupPrefix)
        .do(response => this.finishPrefixSave(response, submittedName));
    }
    return Observable.of({});
  }

  saveSelectedSchedules(list) {
    const selectedIds = list
      .filter(item => item.selected)
      .map(item => item.id);
    this.editAllDivisions(selectedIds);
  }

  retryGroups(): void {
    this.prefixService.getPrefixesForGroup(this.id)
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe((response: HttpResponse<Prefix[]>) => this.applyPrefixResponse(response),
        () => this.isLoaded = true);
  }

  private applyPrefixResponse(response: HttpResponse<Prefix[]>): void {
    this.isLoaded = true;
    if (response.status !== HTTP_OK && response.status !== HTTP_NO_CONTENT) { return; }
    const prefixes = response.body || [];
    this.myCroupPrefix = prefixes.length ? prefixes[FIRST_INDEX] : null;
    this.loadedPrefixName = this.myCroupPrefix ? this.myCroupPrefix.name : null;
    this.prefixService.setGroupPrefixex(prefixes);
    this.prefixService.setSelectedPrefix(this.myCroupPrefix);
    this.prefix = this.loadedPrefixName || EMPTY_TEXT;
  }

  private finishPrefixSave(response: HttpResponse<Object>, submittedName: string): void {
    if (response.status !== HTTP_OK && response.status !== HTTP_ALREADY_REPORTED) {
      throw new Error(PREFIX_SAVE_ERROR);
    }
    this.loadedPrefixName = submittedName;
  }


  getSchedulesList(): void {
    this.schedulesLoading = true;
    this.schedulesLoaded = false;
    this.adminService.getSchedules().takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe((response: HttpResponse<EditorSchedules>) => this.applySchedulesResponse(response),
        () => this.failSchedulesLoad());
  }

  private applySchedulesResponse(response: HttpResponse<EditorSchedules>): void {
    if (response.status !== HTTP_OK || !response.body || !Array.isArray(response.body.STANDARD)
      || !Array.isArray(response.body.FLEXIBLE)) {
      this.failSchedulesLoad();
      return;
    }
    const selectedIds = [this.selectedScheduleId, this.selectedScheduleId2, this.selectedScheduleId3];
    this.schedulesListNoFormated = response.body.STANDARD.filter(schedule => !selectedIds.includes(schedule.id));
    this.sheduleListFlexible = response.body.FLEXIBLE;
    this.initializeDropdowns();
    this.schedulesLoaded = true;
    this.schedulesLoading = false;
    this.getAffiliates();
  }

  private failSchedulesLoad(): void {
    this.schedulesLoading = false;
    this.schedulesLoaded = false;
    this.failGroupLoad(SCHEDULES_LOAD_ERROR);
  }

  initializeDropdowns() {
    this.dropdowns = this.sheduleListFlexible.map(item => ({
      id: item.id,
      open: false,
      selectedScheduleName: `${item.workStart} - ${item.workEnd}`,
      schedules: item.segments || [],
      selected: this.flexShedulesDeratment.some(otherItem => otherItem.id === item.id)
    }));
    this.originalDropdowns = JSON.parse(JSON.stringify(this.dropdowns));
  }

  getDepartments(): void {
    this.adminService.getDepartmentGroups().takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe((response: HttpResponse<Group[]>) => this.applyDepartmentsResponse(response),
        () => this.failDepartmentsLoad());
  }

  private applyDepartmentsResponse(response: HttpResponse<Group[]>): void {
    if (response.status !== HTTP_OK) {
      this.failGroupLoad(DEPARTMENTS_LOAD_ERROR);
      return;
    }
    this.subdivisions = response.body;
    const controls = this.subdivisions.map(group => new FormControl(this.isSelectedSubdivision(group.id)));
    this.departmentsForm = this.fb.group({ subdivisions: new FormArray(controls) });
    this.getSubdivisionsErrorInfo = false;
    this.noSubdivisionsInfo = !this.subdivisions.length;
    if (this.noSubdivisionsInfo) { this.selectedSubdivision = NO_SUBDIVISIONS; }
    this.isLoaded = true;
    this.showErrorMsg = false;
    this.loadingErrorMsg = EMPTY_TEXT;
  }

  private failDepartmentsLoad(): void {
    this.noSubdivisionsInfo = true;
    this.getSubdivisionsErrorInfo = true;
    this.selectedSubdivision = SUBDIVISIONS_ERROR_TEXT;
    this.failGroupLoad(DEPARTMENTS_LOAD_ERROR);
  }

  getAffiliates(): void {
    this.adminService.getAffiliateGroups().takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe((response: HttpResponse<Group[]>) => this.applyAffiliatesResponse(response),
        () => this.failAffiliatesLoad());
  }

  private applyAffiliatesResponse(response: HttpResponse<Group[]>): void {
    if (response.status !== HTTP_OK) {
      this.failGroupLoad(AFFILIATES_LOAD_ERROR);
      return;
    }
    this.affiliates = response.body;
    this.getAffiliatesErrorInfo = false;
    this.noAffiliatesInfo = !this.affiliates.length;
    if (this.noAffiliatesInfo) { this.selectedAffiliate = NO_AFFILIATES; }
    else { this.selectAffiliate(this.affiliates[FIRST_INDEX]); }
    this.getGlobals();
  }

  private failAffiliatesLoad(): void {
    this.noAffiliatesInfo = true;
    this.getAffiliatesErrorInfo = true;
    this.selectedAffiliate = AFFILIATES_ERROR_TEXT;
    this.failGroupLoad(AFFILIATES_LOAD_ERROR);
  }

  getGlobals(): void {
    this.adminService.getGlobalGroups().takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe((response: HttpResponse<Group[]>) => this.applyGlobalsResponse(response),
        () => this.failGlobalsLoad());
  }

  private applyGlobalsResponse(response: HttpResponse<Group[]>): void {
    if (response.status !== HTTP_OK) {
      this.failGroupLoad(GLOBALS_LOAD_ERROR);
      return;
    }
    this.globals = response.body;
    this.getGlobalsErrorInfo = false;
    this.noGlobalsInfo = !this.globals.length;
    if (this.noGlobalsInfo) { this.selectedAffiliate = NO_GLOBALS; }
    else { this.selectGlobal(this.globals[FIRST_INDEX]); }
    this.affiliates.forEach(affiliate => {
      if (affiliate.id === this.group.relativeGroup[FIRST_INDEX]) { this.selectAffiliate(affiliate); }
    });
    this.getDepartments();
  }

  private failGlobalsLoad(): void {
    this.noGlobalsInfo = true;
    this.getGlobalsErrorInfo = true;
    this.selectedGlobal = GLOBALS_ERROR_TEXT;
    this.failGroupLoad(GLOBALS_LOAD_ERROR);
  }

  selectedSchedule(schedule, index) {
    if (this.workSchedule) {
      this.schedulesListNoFormated.push(this.workSchedule);
      this.schedulesListNoFormated.splice(index, 1);
    } else {
      this.schedulesListNoFormated.splice(index, 1);
    }
    this.workSchedule = schedule;
    this.group.workSchedule = schedule;
    this.selectedScheduleName = schedule.workStart.substr(0, schedule.workStart.length - 3) + ' - ' + schedule.workEnd.substr(0, schedule.workEnd.length - 3);
    this.selectedScheduleId = schedule.id;
  }

  selectedSchedule2(schedule, index) {
    if (this.workSchedule2) {
      this.schedulesListNoFormated.push(this.workSchedule2);
      this.schedulesListNoFormated.splice(index, 1);
    } else {
      this.schedulesListNoFormated.splice(index, 1);
    }
    this.workSchedule2 = schedule;
    this.group.workSchedule2 = schedule;
    this.selectedScheduleName2 = schedule.workStart.substr(0, schedule.workStart.length - 3) + ' - ' + schedule.workEnd.substr(0, schedule.workEnd.length - 3);
    this.selectedScheduleId2 = schedule.id;
  }

  selectedSchedule3(schedule, index) {
    if (this.workSchedule3) {
      this.schedulesListNoFormated.push(this.workSchedule3);
      this.schedulesListNoFormated.splice(index, 1);
    } else {
      this.schedulesListNoFormated.splice(index, 1);
    }
    this.workSchedule3 = schedule;
    this.group.workSchedule3 = schedule;
    this.selectedScheduleName3 = schedule.workStart.substr(0, schedule.workStart.length - 3) + ' - ' + schedule.workEnd.substr(0, schedule.workEnd.length - 3);
    this.selectedScheduleId3 = schedule.id;
  }

  selectType(type) {
    if (type === 'AFFILIATE') {
      this.isAffiliate = true;
      this.isDepartment = false;
      this.selectedSubdivisions = [];
    }
    if (type === 'DEPARTMENT') {
      this.isAffiliate = false;
      this.isDepartment = true;
      this.selectedSubdivisions = [];
    }
    if (type === 'GLOBAL') {
      this.selectedSubdivisions = [];
      this.isAffiliate = false;
      this.isDepartment = false;
      this.selectSubdivision('');
    }
    this.selectedType = type;
  }

  selectSubdivision(subdivision) {
    this.selectedSubdivision = subdivision.name;
    this.selectedSubdivisionId = subdivision.id;
  }

  selectAffiliate(affiliate) {
    this.selectedAffiliate = affiliate.name;
    this.selectedAffiliateId = affiliate.id;
    this.selectedAffiliateObj = affiliate;
  }

  selectGlobal(global) {
    this.selectedGlobal = global.name;
    this.selectedGlobalId = global.id;
  }

  appendSubdivision(subdivision) {
    if (this.selectedSubdivisions.includes(subdivision)) {
      const index: number = this.selectedSubdivisions.indexOf(subdivision);
      if (index !== -1) {
        this.selectedSubdivisions.splice(index, 1);
      }
    } else {
      this.selectedSubdivisions.push(subdivision);
    }
  }

  isSelectedSubdivision(subdivision) {
    return this.selectedSubdivisions.includes(subdivision);
  }

  editDivision(list: string[]): void {
    if (!this.canSaveSettings) { return; }
    const request = this.groupSettingsRequest(list);
    this.beginGroupSave();
    this.saveEditedPrefix().switchMap(() => this.adminService.updateGroup(request))
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(() => this.finishGroupSave(), error => this.failGroupSave(error));
  }

  private beginGroupSave(): void {
    this.isLoading = true;
    this.errorMsg = EMPTY_TEXT;
    this.successInfo = false;
    this.errorInfo = false;
    this.errorName = false;
    this.constName = null;
  }

  private groupSettingsRequest(flexibleWorkSchedules: string[]): EditorGroupRequest {
    const request: EditorGroupRequest = {
      id: this.group.id, name: this.titleValue === this.currentGroupName ? null : this.titleValue,
      workScheduleId: this.selectedScheduleId,
      workScheduleId2: this.selectedScheduleId2 || null, workScheduleId3: this.selectedScheduleId3 || null,
      workScheduleCheckvox: this.workScheduleCheckvox, workSchedule2Checkvox: this.workSchedule2Checkvox,
      workSchedule3Checkvox: this.workSchedule3Checkvox, flexibleWorkSchedules: flexibleWorkSchedules,
      groupType: this.selectedType,
      relativeGroup: this.selectedType === AFFILIATE_TYPE ? this.selectedSubdivisions : [this.selectedSubdivisionId]
    };
    if (this.groupContext.parentDepartment || this.groupContext.subdepartments.length) {
      request.groupType = this.group.groupType;
      request.relativeGroup = (this.group.relativeGroup || []).slice();
    }
    return request;
  }

  private finishGroupSave(): void {
    this.isLoading = false;
    this.currentGroupName = this.titleValue;
    this.messageDanger = EMPTY_TEXT;
    this.messageSuccess = SCHEDULE_UPDATED;
    Observable.timer(SAVE_SUCCESS_DELAY).takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(() => this.messageSuccess = EMPTY_TEXT);
  }

  private failGroupSave(error: HttpErrorResponse): void {
    this.isLoading = false;
    this.messageSuccess = EMPTY_TEXT;
    this.messageDanger = SETTINGS_SAVE_ERROR;
    if (this.isSettingsAccessDenied(error)) {
      this.groupChanged$.next();
      this.failGroupContext();
    }
  }

  private isSettingsAccessDenied(error: HttpErrorResponse): boolean {
    return !!error && (error.status === HTTP_FORBIDDEN || error.status === HTTP_UNAUTHORIZED);
  }

  moveToGlobal() {
    const group = {
      parentName: this.selectedGlobal,
      id: this.group.id,
      relativeGroup: this.currentGroupRelatives
    };
    this.moveToType = 'global';
    this.adminService.convertGroup(group, this.moveToType).subscribe(
      (response: any) => {
        if (response.status === 200) {
          if (this.currentGroupType === 'DEPARTMENT') {
            this.convertGroupType();
          } else if (this.currentGroupType === 'GLOBAL' || this.currentGroupType === 'AFFILIATE') {
            this.addRelative();
          }
        } else {
          this.errorMsg = 'ERROR_MOVING_TO_GLOBAL';
          this.successInfo = false;
          this.errorInfo = true;
        }
      },
      () => {
        this.errorMsg = 'ERROR_MOVING_TO_GLOBAL';
        this.successInfo = false;
        this.errorInfo = true;
      }
    );
  }

  convertGroupType() {
    const group = {
      id: this.group.id,
      relativeGroup: []
    };
    if (this.selectedType === 'GLOBAL') {
      group.relativeGroup = null;
    }
    if (this.currentGroupType === 'AFFILIATE') {
      group.relativeGroup = [];
      group.relativeGroup.push(this.selectedGlobalId);
      this.moveToType = 'global';
    }
    if (this.currentGroupType === 'DEPARTMENT') {
      group.relativeGroup = [];
      group.relativeGroup.push(this.selectedAffiliateId);
      this.moveToType = 'affiliate';
    }
    this.adminService.convertGroup(group, this.moveToType).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.successInfo = true;
          this.errorInfo = false;
          this.errorName = false;
        } else {
          this.errorMsg = 'ERROR_CONVERTING_GROUP_TYPE';
          this.successInfo = false;
          this.errorInfo = true;
        }
      },
      () => {
        this.errorMsg = 'ERROR_CONVERTING_GROUP_TYPE';
        this.successInfo = false;
        this.errorInfo = true;
      }
    );
  }

  addRelative() {
    const group = {
      id: this.group.id,
      relativeGroup: []
    };
    if (this.selectedType === 'AFFILIATE') {
      group.relativeGroup = this.selectedSubdivisions;
    }
    if (this.selectedType === 'GLOBAL') {
      group.relativeGroup = this.selectedSubdivisions;
    }
    if (this.currentGroupType === 'DEPARTMENT') {
      group.relativeGroup.push(this.selectedAffiliateId);
    }
    group.relativeGroup.forEach(rg => {
      if (rg === null) {
        const index = group.relativeGroup.indexOf(rg);
        group.relativeGroup.splice(index, 1);
      }
    });
    this.adminService.addRelative(group).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.successInfo = true;
          this.errorInfo = false;
          this.errorName = false;
        } else {
          this.errorMsg = 'ERROR_ADDING_RELATIVE_GROUPS';
          this.successInfo = false;
          this.errorInfo = true;
        }
      },
      () => {
        this.errorMsg = 'ERROR_ADDING_RELATIVE_GROUPS';
        this.successInfo = false;
        this.errorInfo = true;
      }
    );
  }

  isGroupNameValid(name: string) {
    if (name.startsWith(' ') || name.endsWith(' ')) {
      return false;
    }
    const spaces = name.search(/ {2,}/g);
    if (spaces > 0) {
      return false;
    }
    return !(name == null || name.length < 5 || isUndefined(name));
  }

  editAllDivisions(flexibleWorkSchedules: string[]): void {
    if (!this.canSaveSettings) { return; }
    this.beginGroupSave();
    this.adminService.updateGroup(this.groupSettingsRequest(flexibleWorkSchedules))
      .takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(() => this.finishGroupSave(), error => this.failFlexibleGroupSave(error));
  }

  private failFlexibleGroupSave(error: HttpErrorResponse): void {
    const parsedData = error && error.status === HTTP_CONFLICT && error.error && typeof error.error.message === STRING_TYPE
      ? this.parseString(error.error.message) : [];
    if (!parsedData.length) {
      this.failGroupSave(error);
      return;
    }
    this.dropdowns = JSON.parse(JSON.stringify(this.originalDropdowns));
    this.updateDropdownsWithParsedData(this.dropdowns, parsedData);
    this.isLoading = false;
    this.messageSuccess = EMPTY_TEXT;
    this.messageDanger = SCHEDULE_CONFLICT;
    Observable.timer(SAVE_CONFLICT_DELAY).takeUntil(this.groupChanged$).takeUntil(this.destroy$)
      .subscribe(() => this.messageDanger = EMPTY_TEXT);
  }

  updateDropdownsWithParsedData(dropdowns, parsedData) {
    parsedData.forEach(parsedItem => {
      dropdowns.forEach(dropdown => {
        if (dropdown.id === parsedItem.scheduleId) {
          parsedItem.selectedScheduleName = dropdown.selectedScheduleName; 
          dropdown.selectedScheduleName = parsedItem.teamName; 
        }
      });
    });
    this.constName = parsedData;
  }

  parseString(input: string) {
    const regex = /CreateUpdateDto\(teamName=([^,]+),\s*scheduleId=([a-z0-9]+)\)/gi;
    let matches;
    const parsedData = [];
  
    while ((matches = regex.exec(input)) !== null) {
      parsedData.push({
        teamName: matches[1],
        scheduleId: matches[2],
        selectedScheduleName: null 
      });
    }
  
    return parsedData;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/edit-group-details/edit-group-details.component.ts